import React, { ComponentProps } from 'react'

import { styled } from 'nativewind'

import { Icon } from '../icons/Icon'
import { XStack } from '../layout'
import { B2, B5 } from '../typography/Typography'

const ChipContainer = styled(XStack, 'rounded justify-between items-center ', {
  variants: {
    size: {
      small: '  py-0.5 px-2',
      medium: ' py-1 px-2',
      large: ' py-1.5 px-2',
    },
    type: {
      solid: 'bg-grays-20',
      outlined: 'bg-transparent border-[1px]',
    },
  },
  defaultProps: {
    size: 'medium',
    type: 'solid',
  },
})

const LogoContainer = styled(XStack, 'justify-start items-center flex-1')

const SmallTitle = styled(B5, 'ml-1 flex-1')
const Title = styled(B2, 'flex-1')

type ChipContainerProps = ComponentProps<typeof ChipContainer>
type LogoContainerProps = ComponentProps<typeof LogoContainer>

type ChipProps = LogoContainerProps &
  ChipContainerProps & {
    size?: 'small' | 'medium' | 'large' | undefined
    type?: 'solid' | 'outlined'
    primaryIconSize?: number
    primaryIconColor?: string
    secondaryIconSize?: number
    secondaryIconColor?: string
    children?: React.ReactNode
    secondaryIconType?: string
    primaryImage?: string
    primaryIconType: string
    LeadingIconComponent: React.ReactElement
  } & ({ primaryImage: string } | { primaryIconType: string })

export function Chip({
  size,
  type,
  primaryImage,
  primaryIconType,
  primaryIconSize,
  primaryIconColor,
  secondaryIconType,
  secondaryIconSize,
  secondaryIconColor,
  LeadingIconComponent,
  children,
  ...props
}: ChipProps) {
  const getChipIconSize = () => {
    if (primaryIconSize) return primaryIconSize
    else if (size === 'small') return 16

    return 20
  }

  const getSecondaryIconSize = () => {
    if (secondaryIconSize) return secondaryIconSize
    else if (size === 'small') return 16

    return 20
  }

  return (
    <ChipContainer size={size} type={type} {...props}>
      <LogoContainer>
        {LeadingIconComponent ? (
          <XStack className={children ? 'mr-2' : ''}>
            {LeadingIconComponent}
          </XStack>
        ) : primaryIconType ? (
          <Icon
            className={children ? 'mr-2' : ''}
            type={primaryIconType}
            size={getChipIconSize()}
            color={primaryIconColor}
          />
        ) : (
          <></>
        )}
        {Boolean(children) &&
          (size === 'small' ? (
            <SmallTitle className="ml-2">{children}</SmallTitle>
          ) : (
            <Title className="mx-2">{children}</Title>
          ))}
      </LogoContainer>

      {secondaryIconType && (
        <Icon
          className={size === 'small' ? 'ml-1' : 'ml-2'}
          type={secondaryIconType}
          size={getSecondaryIconSize()}
          color={secondaryIconColor}
          // className="flex-2 border "
        />
      )}
    </ChipContainer>
  )
}
